export default {
	pcs_search_placeholder: 'Search phone models',
	pcs_price_starts_from: 'Prices from',
	pcs_zero_source_found: 'No source found',
	pcs_one_source_found: '1 source found',
	pcs_multiple_sources_found: '{count} sources found',
	pcs_breadcrumb_home: 'Buyandship',
	pcs_product_prices_tab: 'Best deals / Price comparison',
	pcs_product_details_tab: 'Smartphones',
	pcs_show_order_avail: 'Show Availability',
	pcs_product_last_updated: 'Last Update:',
	pcs_product_place_order: 'Place Order',
	pcs_product_detail_header: 'Product Details',
	pcs_product_detail_name: 'Product Name',
	pcs_product_detail_description: 'Description',
	pcs_product_detail_brand: 'Brand',
	pcs_product_detail_category: 'Category',

	pcs_filter_button_name: 'Filter',
	pcs_filter_clear_all: 'Clear All',
	pcs_filter_apply: 'Apply',
	pcs_singular_result: 'Result',
	pcs_plural_result: 'Results',
	pcs_filter_brand: 'Brand',
	pcs_filter_colours: 'Colours',
	pcs_filter_price: 'Price',
	pcs_filter_range_options_range1: 'Up to HK$1,000',
	pcs_filter_range_options_range2: 'HK$1,000 - HK$9,000',
	pcs_filter_range_options_range3: 'At least HK$9,000',
	pcs_filter_source: 'Source',
	pcs_filter_specifications: 'Specifications',
	pcs_button_wait: 'Loading...',
	pcs_button_show_more: 'View more',
	pcs_result_price_start_from: 'From',
	pcs_result_price_start_end: '',
	pcs_no_results_found: 'Currently, no products are available for ordering.',
	pcs_no_results_found_for: '0 result for',
	pcs_advise_reset_filter: 'Please check back later or explore other products.',
	pcs_advise_check_keyword:
		'No products match your search. You may try another product.',
	pcs_auto_translated_message: 'Automatic translation is on.',
	pcs_show_original_language: 'Show original',
	pcs_hide_original_language: 'Hide original',
	pcs_you_searched_for: 'Search results for',
	pcs_no_order_available: 'There is no order available at this time',
	pcs_404_not_found: 'Page not found',
	pcs_404_message: 'Please check the address and try again',
	pcs_404_back_to_home: 'Back to homepage',
}
